function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import Types from 'prop-types';
import classNames from 'classnames';
import NavTypes from '../../../NavTypes';
import ButtonItem from '../ButtonItem';
import Items from '../Menu/Items';
import { interpolateLinkForLocale, LocaleValues, SupportedBusinessLocales } from '../../../common/l10n';
var Tabs = function Tabs(_ref) {
  var navType = _ref.navType,
    isPillNavigation = _ref.isPillNavigation,
    personalNavItems = _ref.personalNavItems,
    inverse = _ref.inverse,
    language = _ref.language,
    availableLanguages = _ref.availableLanguages,
    activePath = _ref.activePath,
    onCloseMenu = _ref.onCloseMenu,
    onLanguageChange = _ref.onLanguageChange,
    businessTabLink = _ref.businessTabLink,
    personalTabLink = _ref.personalTabLink,
    locale = _ref.locale,
    availableLocales = _ref.availableLocales,
    onLocaleChange = _ref.onLocaleChange,
    withCountrySelector = _ref.withCountrySelector;
  var _useState = useState(navType),
    _useState2 = _slicedToArray(_useState, 2),
    navigationType = _useState2[0],
    setNavigationType = _useState2[1];
  var handleNavigationTypeChange = function handleNavigationTypeChange(type) {
    setNavigationType(type);
  };
  var showBusinessNav = function showBusinessNav() {
    if (SupportedBusinessLocales[locale.toUpperCase()] || navigationType === NavTypes.BUSINESS) {
      return true;
    }
    return false;
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames(' tw-public-nav__list tw-public-nav__tabs')
  }, /*#__PURE__*/React.createElement(ButtonItem, {
    link: interpolateLinkForLocale(personalTabLink, locale),
    translationKey: "public-navigation.personal",
    deEmphasize: true,
    active: navigationType === NavTypes.PERSONAL,
    isTabItem: true,
    isPillNavigation: isPillNavigation,
    onNavigationTypeChange: function onNavigationTypeChange() {
      handleNavigationTypeChange();
    },
    items: personalNavItems,
    inverse: inverse,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu
  }, isPillNavigation && navigationType === NavTypes.PERSONAL && /*#__PURE__*/React.createElement(Items, {
    items: personalNavItems,
    inverse: inverse,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath,
    "data-testid": "mainmenu"
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu,
    className: classNames('tw-public-nav__main', {
      'tw-public-nav__pill-list': isPillNavigation
    }),
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    withCountrySelector: withCountrySelector
  })), showBusinessNav() ? /*#__PURE__*/React.createElement(ButtonItem, {
    link: interpolateLinkForLocale(businessTabLink, locale),
    translationKey: "public-navigation.business",
    deEmphasize: true,
    active: navigationType === NavTypes.BUSINESS,
    isTabItem: true,
    isPillNavigation: isPillNavigation,
    onNavigationTypeChange: function onNavigationTypeChange() {
      handleNavigationTypeChange();
    },
    items: personalNavItems,
    inverse: inverse,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu
  }, isPillNavigation && navigationType === (NavTypes.BUSINESS || NavTypes.PERSONAL) && /*#__PURE__*/React.createElement(Items, {
    items: personalNavItems,
    inverse: inverse,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath,
    "data-testid": "mainmenu"
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu,
    className: classNames('tw-public-nav__main', {
      'tw-public-nav__pill-list': isPillNavigation
    }),
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    withCountrySelector: withCountrySelector
  })) : null);
};
Tabs.defaultProps = {
  isPillNavigation: false,
  inverse: true,
  activePath: undefined,
  onCloseMenu: false,
  availableLanguages: null,
  availableLocales: null,
  onLanguageChange: function onLanguageChange() {},
  onLocaleChange: function onLocaleChange() {},
  locale: '',
  withCountrySelector: false
};
export default Tabs;